import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      // Scroll the main window
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      
      // Also scroll document elements as fallback
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Find and scroll any scrollable containers that might be the main content area
      const scrollableElements = document.querySelectorAll('[style*="overflow"], .overflow-auto, .overflow-y-auto, .overflow-scroll');
      scrollableElements.forEach(element => {
        if (element instanceof HTMLElement) {
          element.scrollTop = 0;
        }
      });
    };

    // Try immediate scroll
    scrollToTop();
    
    // Also try after a short delay to ensure DOM is ready
    const timeoutId = setTimeout(scrollToTop, 10);
    
    // And one more time after a longer delay for any async content
    const longerTimeoutId = setTimeout(scrollToTop, 100);
    
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(longerTimeoutId);
    };
  }, [pathname]);

  return null;
}